import { addMasterCategories, changeMasterCategories, getMasterCategoryList } from 'owa-categories';
import { action } from 'satcheljs/lib/legacy';
export var addCategory = action('addCategory')(function addCategory(id, name, colorId) {
    var masterList = getMasterCategoryList();
    var matchingCategories = masterList.filter(function (existingCategory) { return existingCategory.Id === id; });
    if (matchingCategories.length > 0) {
        throw new Error('addCategory: Cannot add a category that already exists');
    }
    // No matching category, add a new one
    var categoryToAdd = {
        Name: name,
        Color: colorId,
        Id: id,
    };
    addMasterCategories([categoryToAdd], 'CategoriesOptions');
});
export var updateExistingCategoryColor = action('updateCategory')(function updateCategory(id, colorId) {
    var masterList = getMasterCategoryList();
    var matchingCategories = masterList.filter(function (existingCategory) { return existingCategory.Id === id; });
    if (matchingCategories.length != 1) {
        throw new Error('UpdateCategoryColor should be called on an existing color');
    }
    var newColorId = +colorId;
    if (matchingCategories[0].Color == newColorId) {
        return;
    }
    matchingCategories[0].Color = newColorId;
    changeMasterCategories([matchingCategories[0]], 'CategoriesOptions');
});
//# sourceMappingURL=addOrUpdateCategory.js.map